// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__vKpa8","customBox":"styles_customBox__B0hK6","contentBox":"styles_contentBox__X+byD","link":"styles_link__EP1zS","headingBox":"styles_headingBox__vOWqb"};